import api from './api';

const dashboardService = {
  async getOverview(reportMonth, signal) {
    const response = await api.get('/dashboard', { params: { report_month: reportMonth }, signal });
    return response.data;
  }
};

export default dashboardService;
